import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loginVisible: false,
  signupVisible: false,
  menuVisible: false,
  voxAuthDialogVisible: false,
  modal: {
    visible: false,
    title: '',
    copy: '',
  }
}

const dialogControlSlice = createSlice({
  name: 'dialogControl',
  initialState,
  reducers: {
    setLoginVisible: (state, visible) => {
      state.loginVisible = visible.payload;
    },
    setSignupVisible: (state, visible) => {
      state.signupVisible = visible.payload;
    },
    setMenuVisible: (state, visible) => {
      state.menuVisible = visible.payload;
    },
    setVoxAuthDialogVisible: (state, visible) => {
      state.voxAuthDialogVisible = visible.payload;
    },
    setModal: (state, action) => {
      state.modal = action.payload;
    },
  }
})

export const { 
  setLoginVisible,
  setSignupVisible, 
  setMenuVisible,
  setVoxAuthDialogVisible,
  setModal,
} = dialogControlSlice.actions
export default dialogControlSlice.reducer